import React, { useContext } from "react";
import styled from "styled-components";
import { ProductOptionStepsContext } from "../../Providers/ProductOptionStepsProvider";
import Modal from "../../UX/Modal/Modal";

const SliderCon = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const BeginLabel = styled.small`
    width: 20%;
    //font-weight: 700;
`;

const EndLabel = styled.small`
    text-align: right;
    width: 20%;
    //font-weight: 700;
`;

const Progress = styled.div`
    width: 50%;
    margin-bottom: 0px;
    border-radius: 4px;
    background-color: #d3d3d3;

    div {
        border-radius: 4px;
        background-color: #d01775;
    }
`;

const StyledTable = styled.table`
    td {
        padding: 1.1rem 0.78125rem;
    }
`;

const ExtraProductOptionInfo = () => {
    const {
        extraInfoModal,
        onCloseExtraInfoModal,
        onSelectProductOption
    } = useContext(ProductOptionStepsContext);

    if (!extraInfoModal || !extraInfoModal.show) {
        return null;
    }

    return (
        <Modal
            size="large"
            onClose={onCloseExtraInfoModal}
            display={extraInfoModal.show}
            loading={false}
            loadText={"Informatie aan het ophalen"}
            title={<h4>{extraInfoModal.content.title}</h4>}
        >
            <div className="flex flex-wrap -mx-2">
                <div className="w-full lg:w-1/2 px-2 mb-4">
                    <a
                        href={extraInfoModal.content.images[0].path}
                        target="_blank"
                    >
                        <img
                            src={extraInfoModal.content.images[0].path}
                            alt={extraInfoModal.content.images[0].alt}
                        />
                    </a>
                </div>
                <div className="w-full lg:w-1/2 px-2">
                    <p className="mb-4">{extraInfoModal.content.description}</p>
                    <div className="mb-4">
                        {extraInfoModal.content.properties && (
                            <table className="w-full table-stack">
                                <tbody>
                                    {extraInfoModal.content.properties.map(
                                        (item, i) => (
                                            <tr  key={i}>
                                                <td className="pb-4" width="30%">
                                                    <b>{item.title}</b>
                                                </td>
                                                <td>
                                                    <SliderCon>
                                                        <BeginLabel>
                                                            {item.begin_label}
                                                        </BeginLabel>
                                                        <Progress>
                                                            <div
                                                                style={{
                                                                    width: `${Number(
                                                                        item.value
                                                                    ) * 10}%`,
                                                                    height: '8px'
                                                                }}
                                                            />
                                                        </Progress>
                                                        <EndLabel>
                                                            {item.end_label}
                                                        </EndLabel>
                                                    </SliderCon>
                                                </td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                    <div>
                        <button
                            onClick={() => {
                                onSelectProductOption(
                                    extraInfoModal.type,
                                    extraInfoModal.value
                                );
                                onCloseExtraInfoModal();
                            }}
                            className="bg-yellow-200 text-yellow-900 px-4 py-2 text-white rounded mr-2 font-bold hover:bg-yellow-400 mb-8"
                        >
                            Selecteer dit materiaal
                        </button>
                    </div>

                    <div className="w-full">
                        <div className="bg-blue-100 border border-blue-300 px-3 py-2 rounded mb-4">
                            <h6 className="text-xl font-bold mb-1 text-blue-500">
                                Kom je er niet uit?
                            </h6>
                            <p className="text-sm">
                                Heb je vragen over de verschillende
                                papiersoorten of wil je iets dat er niet staat?
                                Neem contact met ons op via de chat (hieronder),
                                telefoon (088 2400 240) of email
                                (info@24-drukwerk.nl)
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
export default ExtraProductOptionInfo;
